// app/middleware/notFoundBrazil.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "brazil") {
    throw createError({ statusCode: 404 });
  }
});
